import { ThemeEvents } from '@theme/events';

// Use the same rendered variant response as the native price component.
class EcoProductFacts extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    this.section?.addEventListener(ThemeEvents.variantUpdate, this.updateFacts);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(ThemeEvents.variantUpdate, this.updateFacts);
  }

  updateFacts = (event) => {
    const productId = String(event.detail?.data?.productId ?? '');
    if (productId !== this.dataset.productId) return;
    const updated = event.detail?.data?.html?.querySelector(
      `ec-product-facts[data-product-id="${this.dataset.productId}"] .ec-product-facts`
    );
    const current = this.querySelector('.ec-product-facts');
    if (updated && current) current.replaceWith(updated.cloneNode(true));
  };
}

if (!customElements.get('ec-product-facts')) {
  customElements.define('ec-product-facts', EcoProductFacts);
}
